import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import LoginPage from "../scenes/login";
import ErrorPage from "./ErrorPage";
import Layout from "../scenes/layout";
import Companies from "../scenes/companies";
import Branches from "../scenes/branches";
import Licenses from "../scenes/licenses";
import Users from "../scenes/users";
import AccessRoute from "./AccessRoute";
import {TYPE_APPOINTMENTS, TYPE_MOBILE, TYPE_SURVEY} from "../constants/projectTypes";
import AppointmentsMobileConnections from "../scenes/appointments/appointmentsMobileConnections";
import AppointmentsServerTasks from "../scenes/appointments/appointmentsServerTasks";
import AppointmentsHooks from "../scenes/appointments/appointmentsHooks";
import MobileServerTasks from "../scenes/mobile/mobileServerTasks";
import MobileProviders from "../scenes/mobile/mobileProviders";
import MobileConnections from "../scenes/mobile-connection";
import { useAuth } from "./AuthProvider";
import Support from "../scenes/support/index.jsx";
import SurveyTemplates from "../scenes/survey-templates/SurveyTemplates.jsx";

const CustomRouter = () => {

    const { isAuthenticated } = useAuth();

    const router = createBrowserRouter([
            {
                element: isAuthenticated ? <Navigate to='/dash/companies' /> : <LoginPage /> ,
                errorElement: <ErrorPage />,
                path: "/",
            },
            {
                element: <Layout />,
                errorElement: <ErrorPage />,
                children: [
                    {
                        path: "dash/companies",
                        element: <Companies />
                    },
                    {
                        path: "dash/branches",
                        element: <Branches />
                    },
                    {
                        path: "dash/licenses",
                        element: <Licenses />
                    },
                    {
                        path: "dash/users",
                        element: <Users />
                    },
                    {
                        path: "dash/support",
                        element: <Support />
                    },

                    //RUTAS MICROSERVICIO APPOINTMENTS
                    {
                        path: "dash/appointments/server-tasks",
                        element: <AccessRoute projectTypes={[TYPE_APPOINTMENTS]}><AppointmentsServerTasks />  </AccessRoute>,
                    },
                    {
                        path: "dash/appointments/hooks",
                        element: <AccessRoute projectTypes={[TYPE_APPOINTMENTS]}><AppointmentsHooks /></AccessRoute>,
                    },
                    {
                        path: "dash/appointments/mobile-connection",
                        element: <AccessRoute projectTypes={[TYPE_APPOINTMENTS]}><AppointmentsMobileConnections /></AccessRoute>,
                    },
                    //RUTAS MICROSERVICIO MOBILE
                    {
                        path: "dash/mobile/server-tasks",
                        element: <AccessRoute projectTypes={[TYPE_MOBILE]}><MobileServerTasks /></AccessRoute>,
                    },
                    {
                        path: "dash/mobile/providers",
                        element: <AccessRoute projectTypes={[TYPE_MOBILE]}><MobileProviders /></AccessRoute>,
                    },
                    //RUTAS MICROSERVICIO SURVEY
                    // server tasks y coneccion con mobile
                    {
                        path: "dash/survey/mobileConnection",
                        element: <AccessRoute projectTypes={[TYPE_SURVEY]}><MobileConnections/></AccessRoute> ,
                    },
                    {
                        path: "dash/survey/templates",
                        element: <AccessRoute projectTypes={[TYPE_SURVEY]}><SurveyTemplates/></AccessRoute> ,
                    },
                ],
            },
        ]
    );

    return <RouterProvider router={router} />
}

export default CustomRouter;